import React from "react"
import { Card, DialogContent, CircularProgress } from "@mui/material"
import { Img } from "components/Img"
import { fallbackImageCategory } from "store/util/fallbackImage"
import IconButton from "@mui/material/IconButton"
import { rootStore } from "store/RootStore"
import { EpgChannelDetailsInfo, ProgramDetailsInfo, PROGRAM_DETAILS_MODE, PROGRAM_ORIGIN } from "scenes/components/EpgChannelDetailsInfo"
//import { EpgChannelDetailsToolsTitleSecondary } from "scenes/components/EpgChannelDetailsTools"
import { EpgChannelRelatedContent } from "../../LiveTv/components/EpgChannelRelatedContent"
import { Player } from "scenes/Player/Player"
import defaultCoverImg from "img/cover-no-photo.gif"
//import { useNavigateRouteAdd } from "components/utils/RouteUtils"
//import { ROUTE_NAMES } from "site-ql/RouteConst"
//import { ErrorMessage } from "components/ErrorMessage"
//import { isPhoneSize, isSafari } from "utils/Utils"
import { observer } from "mobx-react"
//import { CreateComponent } from "components/utils/CreateComponent"
import { LightTooltip } from "components/LightTooltip"
import { posterUrl } from "utils/EventHelpers"
import { title } from "utils/EventHelpers"
import { l10n } from "store/lang/L10n"

import "./../OverlayEventDetails.css"

export const EventComponent = observer(({ page, origin }) => {
	//const navigateRouteAdd = useNavigateRouteAdd()
	console.debug("EventComponent", page.isPlayerPresent, page.isReady)

	let pageRelatedContent = rootStore.page.EpgChannelRelatedContentOverlay
	// Same value as in EpgChannelDetailsInfo.jsx
	const widthBreak = 800

	const closeButtonOverlay = <div className="closeLayer">
		<LightTooltip title={l10n.featureTooltipClose} placement="bottom">
			<IconButton aria-label="Close"
				id="closeOverlay"
				disableRipple={true}
				disableFocusRipple={true}
				className="closeButton" onClick={(event) => {
					event.preventDefault()
					event.stopPropagation()
					// MTVW-624: combined activityStack for related content and search
					page.resetActivity()
					page.setShow(false)
					// MTVW-1078, item 6: prevent intermittent re-display when opening an event
					page.setComponentType(null)
					page.setIsPlayerPresent(false)
				}} data-test="overlay_close">
			</IconButton>
		</LightTooltip>
	</div>
	const resetOverlayDetailsForRelatedContent = () => {
		// MTVW-708: Enable Ansehen button
		rootStore.page.OverlayEventDetails.setPlayEventStarted(false)
		if (rootStore.page.OverlayEventDetails.isPlayerPresent) {
			rootStore.page.OverlayEventDetails.setIsPlayerPresent(false)
		}
	}

	return (
		<div id="eventComponent" className="eventComponent">
			{page.isPlayerPresent === true && (
				<>
					{/*console.debug("opening Player EventComponent", origin)*/}
					<Player defaultCoverImg={defaultCoverImg} playerName={"playerDetailPageVo"} origin={origin}/>
					{(rootStore.page.Player.source.adState?.replay || rootStore.page.Player.source.adState?.fastFwd) && closeButtonOverlay}

					<DialogContent className="movieDetailsContainer  movieDetailsContainerResponsive" data-test="movie_details_container_dialog">
						{rootStore.page.Player.source.Event ? (
							<div className="relatedContentContainer">
								{console.debug("overlay GOT EVENT %o, source %o", rootStore.page.Player?.source?.Event, rootStore.page.Player?.source)}
								<EpgChannelDetailsInfo oEventData={rootStore.page.Player?.source?.Event} page={page} origin={origin} />
							</div>
						) : <div className="spinnerInfo"><CircularProgress size={100} data-test="" /></div>}
						<div className="relatedContentContainer">
							<EpgChannelRelatedContent
								oEventData={rootStore.page.Player?.source?.Event}
								page={pageRelatedContent}
								origin={origin}
								resetOverlay={resetOverlayDetailsForRelatedContent} />
						</div>
					</DialogContent>
				</>
			)}
			{page.isPlayerPresent === false && page.isReady && (
				<div>
					<Card className="moviePreviewWrapper moviePreviewWrapperResponsive" data-test="overlay_poster_image">
						<Img
							// MTVW-820: allocate space while image is not yet loaded for smooth rendering without jumps,
							// see https://www.afasterweb.com/2019/10/30/a-new-way-to-prevent-layout-jank-during-image-load/
							style={{ width: "100%", height: "auto"/*, objectFit: "scale-down"*/ }}
							src={posterUrl(page.oEvent)} width="1920" height="1080"
							// MTVW-831
							params="mode=box&w=1920&h=1080"
							/* no error triggered for invalid picture (e.g. HTML page)
							onError={(e) => {
								e.stopPropagation()
								console.errpr("no image", e)
							}}
							*/
							// if MovieType is not definded: -> fallback to "tv_category_all.png"
							fallback={fallbackImageCategory(page.oEvent?.Title?.MovieType, "tv_category_all.png")}
							hideBefore={true}
							alt={title(page.oEvent)}
							className="movieCover"
						/>
						{closeButtonOverlay}
						{/* MTVW-810: desktop, full info on cover*/}
						{/* MTVW-1161: condition added although it should not be needed, but just in case to avoid double metadata in event details when clicking on next episode */}
						{window.innerWidth > widthBreak && (
							<>
								{console.debug("FROM EventComponent 1", origin)}
								<ProgramDetailsInfo page={page} oEventData={page.oEvent} programDetailsMode={PROGRAM_DETAILS_MODE.desktop} origin={origin} />
							</>
						)}
						{/* MTVW-624: combined activityStack for related content and search */}
						{page.activityStack.length > 0 &&
							<div className="backLayer">
								<IconButton aria-label="Back"
									// img is in css class
									disableRipple={true}
									disableFocusRipple={true}
									className="backContentItemButton"
									// MTVW-624: combined activityStack for related content and search
									onClick={(e) => { e.preventDefault(); e.stopPropagation(); page.restoreActivity() }}
									data-test="overlay_back">
								</IconButton>
							</div>}
						{/* MTVW-810: no central play button anympre
						{page.isPlayButtonEnabled && (
							<IconButton
								className={isPhoneSize() ? "moviePlayButtonMobile" : "moviePlayButton"}
								//sx={{ transition: isSafari() ? "0ms ease-in-out !important" : "250ms ease-in-out !important" }}
								data-test="play_button"
								disableRipple={true}
								disableFocusRipple={true}
								onClick={(event) => {
									//event.nativeEvent.stopImmediatePropagation()
									event.stopPropagation()
									event.preventDefault()
									page.setPlayEvent()
									rootStore.page.LiveTv.memoSelectedEpg = null //MTV-3740 restore the snapshot for the channelList used in EpgChannel.js
									// MTVW-727b: use isInLiveTv
									if (!rootStore.page.Player.isInLiveTv) { // was rootStore.page.Player.playerLiveTvVo.isPlayerActive === false
										page.setIsPlayerPresent(true)
									} else {
										page.setShow(false)
										rootStore.page.MiniEpg.setShow(false)
										// MTVW-624: combined activityStack for related content and search
										page.resetActivity()
										navigateRouteAdd(ROUTE_NAMES.LiveTv)
										setTimeout(() => {
											//window.scrollTo(0, 0)
											const elem = document.getElementById("tvLiveAndDetailsContainer")
											if (elem) elem.scrollTop = 0
										}, 100)
									}
								}}
							>
							</IconButton>
						)}
						*/}
					</Card>
					{/* MTVW-810: full info below cover */}
					{/* MTVW-1161: condition added although it should not be needed, but just in case to avoid double metadata in event details when clicking on next episode */}
					{window.innerWidth <= widthBreak && (
						<>
							{console.debug("FROM EventComponent 2", origin)}
							<ProgramDetailsInfo page={page} oEventData={page.oEvent} programDetailsMode={PROGRAM_DETAILS_MODE.tabletOrMobile} origin={origin} />
						</>
					)}
				</div>
			)}
			{page.isPlayerPresent === false && (
				// active when clicking in TV Guide on a program item
				(<DialogContent className="movieDetailsContainer movieDetailsContainerResponsive" data-test="movie_details_container_dialog">
					{page.isReady &&
						<div className="relatedContentContainer">
							{console.debug("FROM EventComponent 3", origin)}
							<EpgChannelDetailsInfo oEventData={page.oEvent} page={page} origin={origin} />
							<EpgChannelRelatedContent
								oEventData={page.oEvent}
								page={pageRelatedContent}
								origin={origin}
								resetOverlay={resetOverlayDetailsForRelatedContent} />
						</div>}
				</DialogContent>)
			)}
		</div>
	);
})
